export const INTEGRATIONS_TYPES = {
	INTEGRATION_INNER_RANGE: {
		id: 1,
		name: 'Inner Range',
		defaultCategoryIDs: [20, 21, 22] // INNER_RANGE_DOORS, LIFTS, LIFTS_FLOORS
	},
	INTEGRATION_CONTROL: {
		id: 2,
		name: 'Control',
		defaultCategoryIDs: [12, 14, 17, 19] // SMART_LOCKS, SMART_LOCKER, ZEZAMII_ACCESS, ZEZAMII_LOCKERS
	},
	INTEGRATION_TTLOCK: {
		id: 3,
		name: 'TTLock',
		defaultCategoryIDs: [12, 14, 17, 19] // SMART_LOCKS, SMART_LOCKER, ZEZAMII_ACCESS, ZEZAMII_LOCKERS
	},
	INTEGRATION_CONTROL_GATEWAY: {
		id: 4,
		name: 'Control Gateway',
		defaultCategoryIDs: [18] // ZEZAMII_GATEWAYS
	},
	INTEGRATION_TTLOCK_GATEWAY: {
		id: 5,
		name: 'TTLock Gateway',
		defaultCategoryIDs: [13] // SMART_GATEWAYS
	}
};
